import { PropsWithChildren, ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface DetailFieldProps {
  label: ReactNode;
  className?: string;
}

export const DetailField = ({
  label,
  children,
  className,
}: PropsWithChildren<DetailFieldProps>) => (
  <div className={cn("space-y-1", className)}>
    <dt className="text-sm font-medium text-gray-500">{label}</dt>
    <dd className="text-sm text-gray-900">{children}</dd>
  </div>
);
